// IIFE - Immediately Invoked Function Expression
(function (appcode) {

  // The global jQuery object is passed as a parameter
  appcode(window.jQuery, window, document);

}(function ($, window, document) {

  // The $ is now locally scoped 

  // Listen for the jQuery ready event on the document x
  $(function () {

    // The DOM is ready!

    appModule.cssUserAgent();
    appModule.navbar();
    // appModule.bootstrapModal();
    appModule.init();

  });

  // The DOM may not be ready. The rest of the code goes here!

  function updatePosition() {
    setTimeout(function () {
      $.fn.matchHeight._maintainScroll = true;
      $.fn.matchHeight._update();
      if ($('.slick-slider').length > 0) {
        $('.slick-slider').slick('setPosition');
      }
    }, 200);
  }

  window.appModule = function () {};

  $.extend(appModule, {
    cssUserAgent: function () {
      if (Modernizr) {
        $('html').addClass('modernizr');
      }
      if (cssua.ua.ie > 10.0) {
        $('html').addClass('gt-ie10');
      }
      if (cssua.ua.ie > 9.0) {
        $('html').addClass('gt-ie9');
      }
      if (cssua.ua.ie > 8.0) {
        $('html').addClass('gt-ie8');
      }
      if (cssua.ua.ie > 7.0) {
        $('html').addClass('gt-ie7');
      }
      if (cssua.ua.ie < 10.0) {
        $('html').addClass('lt-ie10');
      }
      if (cssua.ua.ie < 9.0) {
        $('html').addClass('lt-ie9');
        $('body').prepend('<div style="position:relative;color:#a94442;background-color:#f2dede;border-bottom:1px solid #a94442;padding:10px;text-align:center;"><p>It looks like you&rsquo;re using an insecure version of Internet Explorer. Using an outdated browser makes your computer unsafe. For the best experience on the web, please update your browser.</p><p><a href="http://browsehappy.com/?locale=en" style="font-weight:bold;display:inline-block;color:#fff;background-color:#a94442;padding:10px 20px;text-decoration:none;">Upgrade now!</a></p></div>');
      }
      if (cssua.ua.ie < 8.0) {
        $('html').addClass('lt-ie8');
      }
    },
    navbar: function () {

      $('#navbar-collapse').on('show.bs.collapse', function () {
        $('body').addClass('open-navbar');
        updatePosition();
      })
      .on('hide.bs.collapse', function () {
        $('body').removeClass('open-navbar');
        updatePosition();
      });

      // $(document).on('click', 'header, .page-section, footer', function () {
      //   var openNavbar = $('body').hasClass('open-navbar');
      //   if (openNavbar) {
      //     $('#navbar-collapse').collapse('hide');
      //   }
      // });

      var screenWidth = $(window).width(),
          _update = function (screenWidth) {
            if ($('body').hasClass('open-navbar')) {
              $('#navbar-collapse').collapse('hide');
              $('#navbar-collapse li.open').removeClass('open');
              $('#navbar-collapse [data-toggle="dropdown"]').attr('aria-expanded', 'false');
            }
          },
          resize = false;
      
      $(window).on('resize', function () {
        if($(this).width() != screenWidth) {
          screenWidth = $(this).width();
          resize = true;
        }
      });
      setInterval(function () {
        if (resize) {
          resize = false;
          _update(screenWidth);
        }
      }, 250);

    },
    bootstrapModal: function () {

      $('div.modal').on('show.bs.modal', function () {
        var modal = this;
        var hash = modal.id;
        window.location.hash = hash;
        window.onhashchange = function () {
          if ($('.modal.in').length > 1) {
            $('.modal.in').last().modal('hide');
          }
          else if ($('.modal.in').length === 1) {
            if (!location.hash) {
              $(modal).modal('hide');
            }
          }
        }
      });

      $('div.modal').on('hidden.bs.modal', function () {
        if ($('.modal.in').length > 1) {
          $('.modal.in').last().modal('hide');
        }
        else if ($('.modal.in').length === 1) {
          history.replaceState('', document.title, window.location.pathname);
        }
      });

      // when close button clicked simulate back
      $('div.modal button.close').on('click', function () {
        window.history.back();
      });

      // when esc pressed when modal open simulate back
      $('div.modal').keyup(function (e) {
        if (e.keyCode == 27) {
          window.history.back();          
        }
      });

      if (window.history && window.history.pushState) {
        $(window).on('popstate', function () {
          var modal = window.location.hash;
          if (modal.substring(0, 7) === '#modal-') {
            $(modal).modal('show');
          }
        });
      }

    },
    init: function () {

      $('[data-submenu]').submenupicker();
      
      if ($('.js-slick').length) {
        $('.js-slick').slick();
      }
      
      if ($('.js-bg-img').length) {
        $('.js-bg-img').imgLiquid();
      }

      if ($('[data-toggle="tooltip"]').length) {
        $('[data-toggle="tooltip"]').tooltip();
      }

      if ($('.js-sticky-footer').length) {
        $('.js-sticky-footer').stickyFooter();
      }

      if ($('.js-nav-selector').length) {
        $('.js-nav-selector').on('change', 'select', function () {
          var navSelector = $(this).closest('.js-nav-selector');
          var target = $(this).val();
          $('a[href="' + target + '"]', navSelector).tab('show');
        });
        $('.js-nav-selector a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
          var navSelector = $(this).closest('.js-nav-selector');
          var hasSelectPicker = navSelector.find('.selectpicker').length;
          var target = $(this).attr('href');
          if (hasSelectPicker > 0) {
            navSelector.find('.selectpicker').selectpicker('val', target); 
          }
          else {
            navSelector.find('select').val(target);
          }
        });
      }

      $('.js-toggle-show-password').on('click', function () {
        var button = $(this),
            text = button.text();
        if (text == 'Show') {
          button.text('Hide');
          button.closest('.form-group').find('input').attr('type', 'text');
        }
        else {
          button.text('Show');
          button.closest('.form-group').find('input').attr('type', 'password');
        }
      });

      $('#modal-role-access').on('show.bs.modal', function (e) {
        var button = $(e.relatedTarget);
        var target = button.attr('data-user-role');
        var navSelector = $(this).find('.js-nav-selector');
        if (target) {
          $('a[href="' + target + '"]', navSelector).tab('show');
        }
      })
      .on('shown.bs.modal', function (e) {
        $.fn.matchHeight._maintainScroll = true;
        $.fn.matchHeight._update();
      });

      $('.js-print').on('click', function (e) {
        e.preventDefault();
        var target = $(this).attr('data-target');
        var exclude = $(this).attr('data-exclude');
        var excludeElements = '';
        var header = $('header').clone();
        if (typeof exclude !== "undefined" && exclude != '') {
          excludeElements = ', ' + exclude;
        }
        $(target).print({
          globalStyles: true,
          mediaPrint: true,
          stylesheet: null,
          noPrintSelector: ".no-print, .navbar-menu, [data-toggle='modal']" + excludeElements,
          iframe: true,
          append: null,
          prepend: header,
          manuallyCopyFormValues: true,
          deferred: $.Deferred(),
          timeout: 750,
          title: null,
          doctype: '<!doctype html>'
        });
      });

      if ($('.js-clone-element').length) {
        $('.js-clone-element').each(function () {
          var uniqueID = '-' + Math.random().toString(36).substr(2, 9) + Date.now(),
              element = $(this),
              data = element.data(),
              cloneElement = data.cloneElement,
              cloneTarget = data.cloneTarget;
          clone = element.clone();
          clone.removeClass('js-clone-element').removeAttr('data-clone').removeAttr('data-clone-target');
          var hasSelectPicker = clone.find('.selectpicker').length;
          if (hasSelectPicker > 0) {
            if (cloneElement) {
              clone.find('.selectpicker').attr('data-clone-element', cloneElement);
            }
            clone.find('.selectpicker').unwrap('.bootstrap-select');
            clone.find('.selectpicker').removeAttr('tabindex');
            clone.find('.selectpicker').removeClass('selectpicker').siblings().remove();
          }
          clone.find('select').removeClass('form-control-s-line');
          if (cloneElement) {
            clone.find('select').attr('data-clone-unique-id', cloneElement + uniqueID).attr('id', cloneElement + '-clone-' + Math.random().toString(36).substr(2, 9) + Date.now());
          }
          else {
            clone.find('select').attr('data-clone-unique-id', 'unique-id' + uniqueID).attr('id', 'unique-id' + '-clone-' + Math.random().toString(36).substr(2, 9) + Date.now());
          }
          if (cloneTarget) {
            $(cloneTarget).prepend(clone);
            $(cloneTarget).find('select').selectpicker();
          }
        });
      }

      $('.js-year-now').text((new Date()).getFullYear());

    }
  });

}));
